/**
 * The accredited target group, as the forms apply it (02.10.2026).
 *
 * The rule and its text come from `/api/teacher-profile/vocabulary` (the
 * server refuses on the same rule); this copy is only the fallback for when
 * the vocabulary has not answered yet.
 *
 *   "ok"      — nothing to say;
 *   "note"    — "Universitar" ticked together with a pre-university cycle;
 *   "blocked" — "Universitar" without any pre-university cycle.
 */

export const FALLBACK_RULE = {
  blocked_level: "Universitar",
  preuniversity: ["Preșcolar", "Primar", "Gimnazial", "Liceal", "Postliceal", "Învățământ special"],
  message:
    "Cursul nu e deschis cadrelor didactice din învățământul universitar. Programul e acreditat de Ministerul " +
    "Educației (OMEC nr. 4712/19.08.2026) pentru personalul didactic de predare din învățământul preuniversitar. " +
    "Dacă predai și la o școală, un liceu sau o grădiniță, bifează și ciclul acela.",
};

export const NOTE_TEXT = "Programul e acreditat pentru activitatea ta din învățământul preuniversitar.";

export function targetGroupState(levels, rule = FALLBACK_RULE) {
  const r = rule || FALLBACK_RULE;
  const chosen = Array.isArray(levels) ? levels : [];
  if (!chosen.includes(r.blocked_level)) return "ok";
  return chosen.some((l) => r.preuniversity.includes(l)) ? "note" : "blocked";
}

/** The warning's first sentence, bold, and the rest. */
export function splitMessage(message) {
  const text = message || FALLBACK_RULE.message;
  const i = text.indexOf(". ");
  return i < 0 ? [text, ""] : [text.slice(0, i + 1), text.slice(i + 2)];
}
